import React, { useEffect, useState } from 'react'
import { ConversationMode, InterViewCurrentTask } from '../../types/interview.type'
import { useInterview } from '../../contexts/interview.context'
import { FaCompressArrowsAlt, FaExpandArrowsAlt, FaVideo, FaVideoSlash, FaVolumeMute, FaVolumeUp } from 'react-icons/fa'
import { MdCallEnd } from 'react-icons/md'
import { BsChatDots, BsChatDotsFill } from 'react-icons/bs'
import SpeechToText from '../../contexts/SpeechToText'
interface Props {
    showChat: boolean
    toggleChat: () => void
    handleClose: () => void
}
const VideoControllers = ({ showChat, toggleChat, handleClose }: Props) => {
    // Get interview state and functions from InterviewContext.
    const { interview, updateInterview } = useInterview()

    // Destructure frequently used interview state values.
    const {
        isVideoOff,
        isFullScreen,
        currentTask,
        selectedLanguage,
        setUp: interviewSetup,
        audioRef,
        isSpeechRecognitionAvailable,
    } = interview

    // Close interivew and navigate to setup page.

    // Local states for responsiveness.
    const [isMobile, setIsMobile] = useState(window.innerWidth < 900)
    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    const [muted, setMuted] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth
            setScreenWidth(width)
            setIsMobile(width < 8)
        }
        handleResize()
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    // Set default language if not already set.
    useEffect(() => {
        if (!selectedLanguage) {
            updateInterview({ selectedLanguage: "en-US" })
        }
    }, [selectedLanguage, updateInterview])


    const handleVideoToggle = () => updateInterview({ isVideoOff: !isVideoOff })
    const handleAIMuteToggle = () => {
        if (audioRef.current) {
            audioRef.current.muted = !audioRef.current.muted
            setMuted(audioRef.current.muted)
        }
    }
    const handleFullScreenToggle = () => updateInterview({ isFullScreen: !isFullScreen })
    const handlePlayPauseToggle = () => {
        if (
            intervieweeTasks.some((task) => task === currentTask) ||
            currentTask === InterViewCurrentTask.PROCESSING_ANSWER
        ) {
            return
        }
        if (audioRef.current?.paused) {
            audioRef.current?.play()
        } else {
            updateInterview({ currentTask: InterViewCurrentTask.NO_TASK_YET })
            audioRef.current?.pause()
        }
    }


    const intervieweeTasks = [
        InterViewCurrentTask.YOU_SPEAKING,
        InterViewCurrentTask.WAITING_YOU_FOR_REPLY,
        InterViewCurrentTask.YOU_TYPING,
    ]

    return (
        <div
            className={`flex items-center mt-3 mobile:mt-0  flex-wrap justify-center w-full max-w-3xl space-x-1 sm:space-x-2 md:space-x-4`}
        >
            {/* <button
                className={`w-12 h-12 rounded-full flex items-center justify-center ${isMuted ? "bg-gray-500" : "bg-gray-700"
                    }`}
                onClick={handleMuteToggle}
            >
                {!isMuted ? (
                    <FaMicrophone size={24} className="text-white" />
                ) : (
                    <FaMicrophoneSlash size={24} className="text-red-300" />
                )}
            </button> */}
            {interviewSetup?.conversationMode === ConversationMode.VIDEO && (
                <button
                    className={`w-12 h-12 rounded-full flex items-center justify-center ${isVideoOff ? "bg-gray-500" : "bg-gray-700"
                        }`}
                    onClick={handleVideoToggle}
                >
                    {isVideoOff ? (
                        <FaVideoSlash size={22} className="text-red-300" />
                    ) : (
                        <FaVideo size={22} className="text-white" />
                    )}
                </button>
            )}

            <button
                className={`w-12 h-12 rounded-full flex items-center justify-center ${audioRef.current?.muted ? "bg-gray-500" : "bg-gray-700"
                    }`}
                onClick={handleAIMuteToggle}
            >
                {audioRef.current?.muted ? (
                    <FaVolumeMute size={22} className="text-red-300" />
                ) : (
                    <FaVolumeUp size={22} className="text-white" />
                )}
            </button>
            <button
                className={`w-12 h-12 rounded-full flex items-center justify-center bg-red-700`}
                onClick={handleClose}
            >
                <MdCallEnd size={22} className="text-white" />
            </button>
            <button
                className={`w-12 h-12 hidden sm:flex rounded-full  items-center justify-center ${isFullScreen ? "bg-gray-500" : "bg-gray-700"
                    }`}
                onClick={handleFullScreenToggle}
            >
                {isFullScreen ? (
                    <FaCompressArrowsAlt size={22} className="text-white" />
                ) : (
                    <FaExpandArrowsAlt size={22} className="text-white" />
                )}
            </button>
            {/* {!interviewSetup?.isAuto && <button
      className={`w-12 h-12 rounded-full flex items-center justify-center ${interviewSetup?.paused ? "bg-gray-500" : "bg-gray-700"
        }`}
      onClick={handlePlayPauseToggle}
    >
      {audioRef.current?.paused ? (
        <Play size={24} className="text-white" />
      ) : (
        <Pause size={24} className="text-white" />
      )}
    </button>} */}
            {
                <button
                    className={`w-12 h-12 md:hidden rounded-full flex items-center justify-center bg-gray-700 text-white shadow-md`}
                    onClick={toggleChat}
                >
                    {showChat ? <BsChatDots size={24} /> : <BsChatDotsFill size={24} />}
                </button>
            }
            {isSpeechRecognitionAvailable && <SpeechToText iconSize={24} />}
        </div>
    )
}

export default VideoControllers